import { DeviceControlRulesWebComponent } from './component/DeviceControlRulesWebComponent';

export { DeviceControlRulesWebComponent };
